import React from 'react';
import Section from '../Global/Section';
export default function Services({ services = [] }) {
	return (
		<Section bgColor='bg-secondary'>
			<div id='services'>
				<div className='mx-auto max-w-7xl px-6 lg:px-8'>
					<div className='mx-auto max-w-2xl lg:mx-0'>
						<h2 className='text-pretty text-4xl font-semibold tracking-tight text-white sm:text-5xl'>
							Services
						</h2>
						<p className='mt-6 text-lg/8 text-gray-100'>
							We specialize in transforming homes with high-quality, stylish window treatments that
							offer both beauty and functionality. Our services are designed to meet every need—from
							personalized consultations and expert installations to a curated selection of window
							treatments that blend elegance with lasting value. We’re committed to ensuring that
							each client enjoys a smooth, stress-free experience that brings their vision to life.
						</p>
					</div>
					<dl className='mx-auto mt-16 grid max-w-2xl grid-cols-1 gap-8 text-base/7 text-gray-100 sm:grid-cols-2 lg:mx-0 lg:max-w-none lg:grid-cols-3 lg:gap-x-16'>
						{services &&
							services.map((value) => (
								<div
									key={value.name}
									className='relative pl-9'
								>
									<dt className='inline font-semibold text-gray-100'>
										<value.icon
											aria-hidden='true'
											className='absolute left-1 top-1 h-5 w-5 text-primary-500'
										/>
										{value.name}{' '}
									</dt>
									<dd className='inline'>{value.description}</dd>
								</div>
							))}
					</dl>
				</div>
			</div>
		</Section>
	);
}
